module.exports = __webpack_public_path__ + "img/type-4.409486f.png";